module.exports = __webpack_public_path__ + "static/schwab-logo-3b93732c0a8dd71fa0f48e672d2bbca1.svg";